import { Injectable } from '@angular/core';
import { RestCallService } from './rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastService } from './toast.service';
import { IShipment } from '../interfaces/IShipment';
import { IShipmentHistory } from '../interfaces/IShipmentHistory';
import { IDeliveryStatus } from '../interfaces/IDeliveryStatus';
//import { NotificationService } from 'src/app/core/services/notification/notification.service';
//import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';

@Injectable({
  providedIn: 'root',
})
export class DeliveryStatusService extends RestCallService {
  constructor(
    public httpClient: HttpClient,
    public toast: ToastService
    //public notificationService: NotificationService,
    //public translate: TranslateApplicationService,
  ) {
    super(
      httpClient,
      'MiAplicacionApi',
      toast,
      //notificationService,
      //translate,
    );
  }

  public getActive() {
    return this.get<IDeliveryStatus[]>(`status/GetActive`);
  }


}
